import { render, staticRenderFns } from "./PasswordsPage.vue?vue&type=template&id=63a390dc"
import script from "./PasswordsPage.vue?vue&type=script&lang=js"
export * from "./PasswordsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports